import { combineReducers, createReducer, on } from '@ngrx/store';
import type { ActionReducer } from '@ngrx/store';
import {
  createUsageQuestionnaireReducer,
  expectedConsumptionDefinedAction,
  type UsageQuestionnaireState,
} from '@innogy/common-ui/sales';
import type { HomeBatteryWizardFormData } from '@feh/homebattery-models';

import { homeBatteryWizardFormSubmitAction } from '../actions';

export const homebatteryWizardSelectorKey = 'homebattery-wizard';
export const HOMEBATTERY_CONSUMPTION_QUESTIONNAIRE_ID =
  'homebattery-consumption-form';

export interface HomeBatteryWizardState {
  consumption: UsageQuestionnaireState;
  formData: HomeBatteryWizardFormData;
}

const initialFormData: HomeBatteryWizardFormData = {
  consumptionPerYear: null,
  address: undefined,
};

const consumptionQuestionaireForm = createUsageQuestionnaireReducer(
  HOMEBATTERY_CONSUMPTION_QUESTIONNAIRE_ID
);

const formDataReducer = createReducer(
  initialFormData,
  on(expectedConsumptionDefinedAction, (state, action) => ({
    ...state,
    consumptionPerYear: action.expectedConsumption.electricity.total,
  })),
  on(homeBatteryWizardFormSubmitAction, (state, action) => ({
    ...state,
    address: action.address,
    consumptionPerYear: action.consumptionPerYear,
  }))
);

export const homeBatteryWizardReducer: ActionReducer<HomeBatteryWizardState> =
  combineReducers({
    consumption: consumptionQuestionaireForm,
    formData: formDataReducer,
  });
